<script lang="ts">
	import { Col, Row, Text } from '@Shelly/shelly-design-system';
	import LottiePlayer from 'src/components/LottiePlayer/LottiePlayer.svelte';
	import { format } from 'svelte-i18n';
</script>

<Text element="h2" class="mb-xs">
	{$format('presence_wizard_furniture_title', { default: 'Furniture layout' })}
</Text>
<p class="step-subtitle mb-l">
	{$format('presence_wizard_furniture_subtitle', {
		default:
			'Add furniture to your radar map to make it easier to understand at a glance. These are visual only and have no effect on detection.',
	})}
</p>

<Row class="d-flex align-items-center">
	<Col sm="12" md="6" lg="6" class="d-flex justify-content-center">
		<LottiePlayer
			src="/images/lottie/radar/FurnituresInfo.json"
			autoplay={true}
			loop={true}
			height={220}
			width={220}
			background="transparent"
		/>
	</Col>
	<Col sm="12" md="6" lg="6">
		<div class="furniture-points">
			<div class="point">
				<i class="fas fa-couch point-icon" aria-hidden="true"></i>
				<p>
					{$format('presence_wizard_furniture_point_1', {
						default: 'Choose from sofas, desks, beds, and more',
					})}
				</p>
			</div>
			<div class="point">
				<i class="fas fa-arrows-rotate point-icon" aria-hidden="true"></i>
				<p>
					{$format('presence_wizard_furniture_point_2', {
						default: 'Drag, rotate, and resize items to match your real room',
					})}
				</p>
			</div>
			<div class="point">
				<i class="fas fa-eye point-icon" aria-hidden="true"></i>
				<p>
					{$format('presence_wizard_furniture_point_3', {
						default: 'Helps correlate radar dots with actual people and positions',
					})}
				</p>
			</div>
		</div>

		<div class="optional-badge">
			<i class="fas fa-star" aria-hidden="true"></i>
			{$format('presence_wizard_furniture_optional', {
				default: 'Completely optional — skip if you prefer a clean map',
			})}
		</div>
	</Col>
</Row>

<style>
	.step-subtitle {
		color: var(--color-text-secondary, rgba(255, 255, 255, 0.55));
		line-height: 1.5;
	}

	.furniture-points {
		display: flex;
		flex-direction: column;
		gap: 14px;
		margin-bottom: 20px;
	}

	.point {
		display: flex;
		align-items: flex-start;
		gap: 10px;
		font-size: 13px;
		line-height: 1.45;
	}

	.point p {
		margin: 0;
	}

	.point-icon {
		flex-shrink: 0;
		margin-top: 1px;
		width: 18px;
		text-align: center;
		color: var(--color-primary, #7c5bff);
		font-size: 14px;
	}

	.optional-badge {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 6px 12px;
		border-radius: 20px;
		font-size: 12px;
		font-weight: 500;
		background: var(--color-surface-2, rgba(255, 255, 255, 0.06));
		color: var(--color-text-muted, rgba(255, 255, 255, 0.45));
	}

	.optional-badge i {
		font-size: 11px;
		color: var(--color-warning, #ffc800);
	}
</style>
